<template>

    <section id="home" style="position:relative">
            <v-img src="~/../../../static/img/mainbk2.jpg">
                <v-layout column align-center justify-center class="white--text">
                    <div class="bklogo-mobile hidden-md-and-up">
                        <img src="~/../../../static/img/logo.png" alt="QuickBe">
                    </div>
                    <div class="bklogo hidden-sm-and-down">
                        <img src="~/../../../static/img/logo.png" alt="QuickBe">
                    </div>
                </v-layout>
            </v-img>
        </section>

</template>
<script>
export default {
  name: 'Header'
}
</script>
<style scoped>
.bklogo-mobile img {
  /* width: 45vh;
  left: calc(50% - (45vh / 2));
  top: calc(50% - (45vh / 2));
  bottom: 0;
  height: 45vh;
  position: relative; */
  height: 100%;
}
.bklogo-mobile {
  height: 200px;
  text-align: center;
}
.bklogo {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/components/frontend/Header.vue